(function () {
'use strict';
if (window.__stAssistant) return;
window.__stAssistant = true;
var dataEl = document.getElementById('st-assistant-data');
if (!dataEl) return;
var CFG;
try { CFG = JSON.parse(dataEl.textContent); } catch (e) { return; }
var PRODUCTS = (CFG.products || []).filter(function (p) { return p && p.h; });
var BY_HANDLE = {};
PRODUCTS.forEach(function (p) { BY_HANDLE[p.h] = p; });
var EMAIL = CFG.email || '';
var STORE_KEY = 'st-assistant-v1';
var MAX_HISTORY = 40;
var TRADES = [
{ key: 'general-contracting', label: 'General Contracting', words: ['general contract', 'contractor', 'gc', 'remodel', 'renovat', 'builder', 'construction', 'handyman', 'carpent'] },
{ key: 'lawn-care', label: 'Lawn Care', words: ['lawn', 'landscap', 'mow', 'yard', 'turf', 'grass', 'snow'] },
{ key: 'tree-care', label: 'Tree Care', words: ['tree', 'arbor', 'stump', 'trim', 'chipper', 'bucket truck'] },
{ key: 'plumbing', label: 'Plumbing', words: ['plumb', 'pipe', 'drain', 'water heater', 'sewer', 'faucet'] },
{ key: 'hvac', label: 'HVAC', words: ['hvac', 'heating', 'cooling', 'air condition', 'furnace', 'heat pump', 'ac ', 'a/c'] },
{ key: 'electrical', label: 'Electrical', words: ['electric', 'electrician', 'wiring', 'panel upgrade', 'breaker', 'outlet', 'service upgrade', 'ev charger'] },
{ key: 'roofing', label: 'Roofing', words: ['roof', 'shingle', 'gutter', 'reroof', 're-roof', 'storm damage', 'hail'] }
];
var ALL_TRADE_TAGS = ['money-tools', 'safety', 'startup', 'service', 'lead-magnet'];
function isAllTrades(p) { var g = p.g || []; for (var i = 0; i < ALL_TRADE_TAGS.length; i++) if (g.indexOf(ALL_TRADE_TAGS[i]) > -1) return true; return false; }
var MAIL = EMAIL ? '[' + EMAIL + '](mailto:' + EMAIL + ')' : 'the contact page';
var KB = [
{ id: 'delivery', w: ['download', 'get my file', 'receive', 'deliver', 'where are my', 'link', 'access my file', 'after i buy', 'didn\'t get', 'did not get', 'email with', 'resend'],
a: 'Right after checkout your download links show on the order confirmation page, and the same links are emailed to you. Most people have their files within a minute or two.\n\nNo email? Check spam or promotions first. Still missing? Email ' + MAIL + ' with your order number and we\'ll resend them.',
chips: ['Order help', 'Talk to a person'] },
{ id: 'formats', w: ['excel', 'google sheet', 'sheets', 'numbers', 'format', 'file type', 'xlsx', 'pdf', 'word', 'open the file', 'software', 'mac', 'windows', 'online'],
a: 'The spreadsheets work in **Microsoft Excel** and free **Google Sheets** (upload the file to Google Drive and open it, it runs online on any device). They also open in Apple Numbers.\n\nForms are fillable **PDFs** you can type into on screen or print. Agreements come as editable **Word** files plus a PDF. Everything is print-ready.',
chips: ['Find a tool for my trade', 'Will it work on my phone?'] },
{ id: 'phone', w: ['phone', 'tablet', 'ipad', 'mobile', 'iphone', 'android', 'in the truck', 'job site'],
a: 'Yes. Google Sheets and most PDF apps work on phones and tablets, so you can fill out a form or check the schedule from the job site.',
chips: ['Find a tool for my trade'] },
{ id: 'brand', w: ['logo', 'company name', 'brand', 'customize', 'customise', 'edit', 'my name on', 'personalize'],
a: 'Yes. Every file has a spot for your business name, logo, phone and license number. Fill it in once, save it as your master copy, and every estimate, invoice and form goes out with your name on it.\n\nRather have us do it? **Branded For You** adds your logo, colors, contact info, tax rate and payment terms for you, back in 3 business days: $29 for one tool, $69 for a toolkit, $99 for a bundle or startup kit. [See how it works](/pages/branded-for-you).',
chips: ['Find a tool for my trade'], cards: ['branded-for-you'] },
{ id: 'free', w: ['free', 'freebie', 'try first', 'sample', 'trial', 'job profit', 'profit calculator', 'did i make money', 'make money on'],
a: 'Yes, there\'s a free one: the **Free Job Profit Calculator**. Enter the price and what the job cost you, and it shows your real profit, margin, profit per hour and what you should have charged. Check out with your email ($0) and the download arrives instantly.',
chips: ['Show business tools', 'Find a tool for my trade'], cards: ['free-job-profit-calculator'] },
{ id: 'startup', w: ['start a business', 'starting a business', 'start my own', 'going out on my own', 'new business', 'just starting', 'getting started', 'launch', 'llc', 'first customers', 'business plan'],
a: 'Going out on your own? The **Start Your Trade Business Kit** ($129) walks you through it in order: a 37-step launch checklist, startup cost planner and break-even calculator, price sheet, one-page business plan, insurance and licensing checklist, a First 10 Customers playbook with scripts, plus the Money Tools and a written safety program.',
chips: ['Show business tools', 'Find a tool for my trade'], cards: ['start-your-trade-business-kit'] },
{ id: 'money', w: ['overhead', 'markup', 'margin', 'hourly rate', 'what to charge', 'how much to charge', 'pricing', 'break even', 'break-even', 'profit and loss', 'p&l', 'expenses', 'bookkeeping', 'mileage'],
a: 'For the money side of the business:\n- **Overhead & Markup Calculator** ($29): your break-even hourly rate and the price to quote for the profit you want.\n- **Profit & Expense Tracker** ($29): monthly P&L, margin and a tax set-aside.\n- **Money Tools Pack** ($59): both of those plus a Mileage & Vehicle Log.\n\nWorth a read: [Markup vs. Margin](/blogs/news/markup-vs-margin-for-contractors).',
chips: ['Show business tools'], cards: ['money-tools-pack', 'overhead-markup-calculator', 'free-job-profit-calculator'] },
{ id: 'legal', w: ['legal', 'binding', 'lawyer', 'attorney', 'contract valid', 'enforceable', 'waiver hold'],
a: 'The agreements and waivers are professionally written starting templates, not legal advice. Laws differ by state, so have a local attorney review them before you rely on them. That still costs far less than having one drafted from scratch.',
chips: ['Show me the agreements'] },
{ id: 'osha', w: ['osha', 'safety', 'compliance', 'toolbox talk', 'compliant'],
a: 'The **Safety Program Pack** ($49) gives you a full year of toolbox talks for all 7 trades (84 talks), incident, near-miss, sign-in and PPE forms, and a written safety program and emergency action plan. These help you run safer jobs and keep a paper trail. They support, but don\'t replace, required training, manufacturer instructions, and OSHA or local rules.',
chips: ['Tell me about memberships'], cards: ['safety-program-pack'] },
{ id: 'license', w: ['share', 'crew use', 'employees', 'resell', 'license', 'multiple users', 'my team', 'give to'],
a: 'You can use the files across your own business, including your employees and crews, and print as many copies as you need. Please don\'t resell them or share them with other businesses.',
chips: [] },
{ id: 'refund', w: ['refund', 'money back', 'return', 'guarantee', 'doesn\'t work', 'broken', 'not working', 'formula', 'wrong product', 'bought the wrong', 'duplicate', 'charged twice'],
a: 'Our **"It Works" guarantee**: if a file won\'t open, a formula is broken, or it isn\'t what the description said, email us within **14 days** and we\'ll fix it, replace it, or refund that product.\n\nBought the wrong trade or the same item twice? We\'ll swap or refund it within 14 days. Bought a single tool and want the bundle? We\'ll credit what you paid toward it.\n\nRefunds for a simple change of mind aren\'t available once files are downloaded. [Read the full refund policy](/policies/refund-policy).',
chips: ['Talk to a person'] },
{ id: 'upgrade', w: ['upgrade', 'credit toward', 'already bought', 'apply what i paid'],
a: 'Bought a single tool and want the full All-in-One Toolkit for your trade? Email ' + MAIL + ' within 14 days with your order number and we\'ll credit what you paid toward the toolkit.',
chips: ['Show toolkits'] },
{ id: 'bundle', w: ['bundle', 'toolkit', 'all-in-one', 'all in one', 'single tool or', 'which should i buy', 'best value', 'save money', 'cheaper'],
a: 'If you need one thing fixed, like invoicing, grab that single tool. If you\'re setting up your business systems, the **All-in-One Toolkit** gets every tool for your trade in one download for less than buying them separately. Want every tool plus updates and new tools? Look at a **membership**.',
chips: ['Show toolkits', 'Tell me about memberships'] },
{ id: 'membership', w: ['membership', 'member', 'subscription', 'subscribe', 'steel toe pro', 'crew plan', 'foreman', 'owner plan', 'monthly', 'yearly', 'annual', 'tiers', 'plans'],
a: '**Steel Toe Pro** memberships:\n- **Crew** $19/month or $190/year: every tool for the one trade you pick, plus a 12-month toolbox talk program.\n- **Foreman** $39/month or $390/year: all 7 trades, the Marketing Kit and Hiring Kit, and a new tool every month.\n- **Owner** $79/month or $790/year: everything in Foreman plus the Owner\'s Business Toolkit and early access to new tools.\n\nYearly plans get 2 months free. Cancel anytime and keep what you\'ve downloaded.',
chips: ['Compare plans', 'How do members download?', 'Cancel a membership'], cards: 'memberships' },
{ id: 'vault', w: ['vault', 'members vault', 'how do members', 'member download', 'free for members', '$0', 'member price', 'member discount'],
a: 'Members download from the **Members Vault**:\n1. Log in with the email you joined with.\n2. Open the [Members Vault](/collections/members-vault).\n3. Add your library to the cart. Your member discount brings it to **$0** at checkout.\n4. Your download links arrive by email like any order.',
chips: ['Log in', 'Open the Members Vault'] },
{ id: 'cancel', w: ['cancel', 'stop my', 'unsubscribe', 'pause', 'end my membership', 'manage my membership', 'change plan', 'switch plan'],
a: 'You can cancel or manage your plan anytime from your account: log in, open your profile, and use **Manage Membership**. Cancelling stops the next renewal; you keep access until the end of the period you paid for, and you keep everything you downloaded.',
chips: ['Log in', 'Talk to a person'] },
{ id: 'account', w: ['log in', 'login', 'sign in', 'my account', 'password', 'create account', 'sign up for account'],
a: 'You can [log in or create your account here](' + (CFG.accountUrl || '/account') + '). You don\'t need an account to buy single tools or toolkits, but memberships use your account to unlock the Members Vault.',
chips: [] },
{ id: 'order', w: ['order', 'my purchase', 'order status', 'receipt', 'invoice for my', 'order number'],
a: 'Logged-in customers can see every order and its download links under [your account](' + (CFG.accountUrl || '/account') + '). Checked out as a guest? Your confirmation email has the links. If anything is missing, email ' + MAIL + ' with your order number.',
chips: ['Talk to a person'] },
{ id: 'payment', w: ['pay', 'payment', 'credit card', 'paypal', 'apple pay', 'shop pay', 'secure', 'checkout safe'],
a: 'Checkout runs on Shopify\'s secure checkout. The payment options available to you are shown at checkout. Memberships renew automatically on the card you join with until you cancel.',
chips: [] },
{ id: 'shipping', w: ['ship', 'shipping', 'delivery time', 'mail it', 'physical', 'printed copy', 'hard copy'],
a: 'Nothing is shipped. Every product is an instant digital download, so there are no shipping charges and no waiting.',
chips: ['How do I get my files?'] },
{ id: 'discount', w: ['discount', 'coupon', 'promo', 'code', 'sale', 'deal'],
a: 'The best savings are built in: each **All-in-One Toolkit** costs less than buying its tools one at a time, and **yearly memberships** get 2 months free. If a promo code is running, you can enter it at checkout.',
chips: ['Show toolkits', 'Tell me about memberships'] },
{ id: 'tax', w: ['tax', 'sales tax', 'write off', 'deduct'],
a: 'Sales tax, if any applies where you are, is calculated at checkout. For whether a purchase is deductible for your business, check with your accountant.',
chips: [] },
{ id: 'custom', w: ['custom', 'make me a', 'build me', 'don\'t see', 'do you have', 'request a', 'other trade', 'paint', 'pest', 'cleaning', 'pool', 'concrete', 'fenc', 'flooring', 'drywall'],
a: 'We build for general contractors, lawn care, tree care, plumbing, HVAC, electrical and roofing, plus **Business Tools** that work for any trade (pricing, profit, safety and a startup kit). If you need something we don\'t make yet, tell us. Requests shape what we build next. Members on Foreman and Owner get a new tool every month.',
chips: ['Show business tools', 'Talk to a person'] },
{ id: 'blog', w: ['blog', 'article', 'tips', 'how to price', 'change order', 'per square foot', 'tree removal cost'],
a: 'Our **Field Notes** blog has practical how-tos:\n- [How to Price a Tree Removal Job](/blogs/news/how-to-price-a-tree-removal-job)\n- [Lawn Mowing Prices per Square Foot](/blogs/news/lawn-mowing-prices-per-square-foot)\n- [How to Write a Change Order That Gets Signed](/blogs/news/how-to-write-a-change-order)\n- [Markup vs. Margin](/blogs/news/markup-vs-margin-for-contractors)',
chips: ['Find a tool for my trade'] },
{ id: 'review', w: ['review', 'leave feedback', 'feedback', 'rate you', 'testimonial'],
a: 'Thank you! You can leave a review on our [review page](/pages/leave-a-review). Tell us what you bought, how it helped and what we could do better.',
chips: [] },
{ id: 'about', w: ['who are you', 'about you', 'who makes', 'company', 'steel toe systems', 'real person', 'are you a bot', 'are you ai', 'are you human'],
a: 'I\'m the Steel Toe assistant, a virtual helper for this store. Steel Toe Systems builds simple business tools for the trades: estimates, invoices, schedules, contracts and safety forms. For anything I can\'t sort out, a real person answers email at ' + MAIL + '.',
chips: ['Talk to a person'] },
{ id: 'contact', w: ['human', 'person', 'agent', 'support', 'contact', 'talk to', 'speak to', 'help me', 'email you', 'phone number', 'call you'],
a: 'Happy to get a real person on it. Leave your name, email and question and we\'ll reply within 2 business days. Or email ' + MAIL + ' directly.',
action: 'handoff' }
];
var GREETING_WORDS = ['hi', 'hello', 'hey', 'yo', 'sup', 'good morning', 'good afternoon', 'howdy'];
var THANKS_WORDS = ['thanks', 'thank you', 'thx', 'appreciate', 'great', 'perfect', 'awesome', 'got it'];
var state = { open: false, history: [], aiTurns: [], nudged: false, unread: 0 };
function load() {
try {
var s = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
if (s) { state.history = s.history || []; state.aiTurns = s.aiTurns || []; state.nudged = !!s.nudged; state.open = !!s.open; }
} catch (e) { /* storage unavailable */ }
}
function save() {
try {
sessionStorage.setItem(STORE_KEY, JSON.stringify({
history: state.history.slice(-MAX_HISTORY), aiTurns: state.aiTurns.slice(-12), nudged: state.nudged, open: state.open
}));
} catch (e) { /* storage unavailable */ }
}
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function safeHref(h) {
h = String(h || '').trim();
if (/^mailto:[^\s"<>]+$/i.test(h)) return h;
if (/^\/(?!\/)[^\s"<>]*$/.test(h)) return h;
try {
var u = new URL(h, location.origin);
if (u.origin === location.origin) return u.pathname + u.search + u.hash;
} catch (e) { /* ignore */ }
return null;
}
function md(text) {
var lines = esc(text).split(/\n/);
var out = [], list = null;
function inline(s) {
s = s.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
s = s.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (m, t, href) {
var raw = href.replace(/&amp;/g, '&');
var ok = safeHref(raw);
return ok ? '<a href="' + esc(ok) + '">' + t + '</a>' : t;
});
return s;
}
lines.forEach(function (ln) {
var b = ln.match(/^\s*[-*]\s+(.*)/), n = ln.match(/^\s*\d+[.)]\s+(.*)/);
if (b || n) {
var tag = b ? 'ul' : 'ol';
if (!list || list.tag !== tag) { if (list) out.push('</' + list.tag + '>'); list = { tag: tag }; out.push('<' + tag + '>'); }
out.push('<li>' + inline((b || n)[1]) + '</li>');
} else {
if (list) { out.push('</' + list.tag + '>'); list = null; }
if (ln.trim()) out.push('<p>' + inline(ln) + '</p>');
}
});
if (list) out.push('</' + list.tag + '>');
return out.join('');
}
function money(cents) {
if (typeof cents !== 'number') return '';
var v = cents / 100;
return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
}
function norm(s) { return ' ' + String(s || '').toLowerCase().replace(/[^a-z0-9$\/'\- ]+/g, ' ').replace(/\s+/g, ' ') + ' '; }
function track(name, detail) {
try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('st_assistant_' + name, detail || {}); } catch (e) { /* ignore */ }
}
function tradeOf(p) {
if (isAllTrades(p)) return null;
for (var i = 0; i < TRADES.length; i++) if ((p.g || []).indexOf(TRADES[i].key) > -1) return TRADES[i];
return null;
}
function detectTrade(q) {
var t = norm(q);
for (var i = 0; i < TRADES.length; i++) {
for (var j = 0; j < TRADES[i].words.length; j++) if (t.indexOf(TRADES[i].words[j]) > -1) return TRADES[i];
}
return null;
}
var STOP = ' a an the i my me for to of and or is it do you we our your can with in on need want looking any some what which how get have does are there this that template templates tool tools please '.split(' ');
function searchProducts(q, trade, limit) {
var words = norm(q).trim().split(' ').filter(function (w) { return w.length > 2 && STOP.indexOf(w) < 0; });
var scored = PRODUCTS.filter(function (p) { return p.k === 'tool'; }).map(function (p) {
var hay = norm(p.t + ' ' + p.d + ' ' + (p.g || []).join(' '));
var title = norm(p.t), s = 0;
words.forEach(function (w) {
var stem = w.replace(/(ing|es|s)$/, '');
if (title.indexOf(stem) > -1) s += 3; else if (hay.indexOf(stem) > -1) s += 1;
});
if (trade && (p.g || []).indexOf(trade.key) > -1) s += 2;
if (trade && (p.g || []).indexOf(trade.key) < 0) s -= 4;
return { p: p, s: s };
}).filter(function (x) { return x.s >= 3; });
scored.sort(function (a, b) { return b.s - a.s; });
return scored.slice(0, limit || 3).map(function (x) { return x.p; });
}
function matchKB(q) {
var t = norm(q), best = null, bestScore = 0;
KB.forEach(function (k) {
var s = 0;
k.w.forEach(function (w) { if (t.indexOf(norm(w).trim()) > -1) s += w.length > 6 ? 2 : 1; });
if (s > bestScore) { bestScore = s; best = k; }
});
return bestScore > 0 ? { k: best, score: bestScore } : null;
}
var root, panel, log, input, form, launcher, badge, nudgeEl, sendBtn;
var ICON_CHAT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v11H8l-4 4z"/><path d="M8 9h8M8 12h5"/></svg>';
var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
var ICON_SEND = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12l16-8-6 16-2-7z"/></svg>';
function build() {
root = document.createElement('div');
root.className = 'sta';
root.innerHTML =
'<div class="sta-nudge" hidden role="status"><button type="button" class="sta-nudge__x" aria-label="Dismiss">' + ICON_X + '</button><span class="sta-nudge__t"></span></div>' +
'<button type="button" class="sta-launch" aria-haspopup="dialog" aria-expanded="false" aria-controls="sta-panel">' +
'<span class="sta-launch__ic">' + ICON_CHAT + '</span><span class="sta-launch__lb">Ask Steel Toe</span><span class="sta-badge" hidden>1</span></button>' +
'<section class="sta-panel" id="sta-panel" role="dialog" aria-modal="false" aria-label="Steel Toe assistant" hidden>' +
'<header class="sta-head"><div class="sta-head__logo" aria-hidden="true">T</div><div class="sta-head__tx"><b>Steel Toe Assistant</b><span>Answers right away. A real person replies within 2 business days.</span></div>' +
'<button type="button" class="sta-icon sta-restart" aria-label="Start over" title="Start over"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.3-5.7M4 4v4h4"/></svg></button>' +
'<button type="button" class="sta-icon sta-close" aria-label="Close chat">' + ICON_X + '</button></header>' +
'<div class="sta-log" role="log" aria-live="polite" aria-relevant="additions"></div>' +
'<form class="sta-form" autocomplete="off"><label class="sta-vh" for="sta-input">Type your question</label>' +
'<textarea id="sta-input" class="sta-input" rows="1" maxlength="800" placeholder="Ask a question..."></textarea>' +
'<button type="submit" class="sta-send" aria-label="Send">' + ICON_SEND + '</button></form>' +
'<div class="sta-foot">Virtual assistant. Answers can be wrong; check product pages and policies before you buy.</div>' +
'</section>';
document.body.appendChild(root);
panel = root.querySelector('.sta-panel');
log = root.querySelector('.sta-log');
input = root.querySelector('.sta-input');
form = root.querySelector('.sta-form');
sendBtn = root.querySelector('.sta-send');
launcher = root.querySelector('.sta-launch');
badge = root.querySelector('.sta-badge');
nudgeEl = root.querySelector('.sta-nudge');
launcher.addEventListener('click', function () { toggle(!state.open); });
root.querySelector('.sta-close').addEventListener('click', function () { toggle(false); launcher.focus(); });
root.querySelector('.sta-restart').addEventListener('click', restart);
form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
input.addEventListener('keydown', function (e) {
if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); }
});
input.addEventListener('input', autosize);
panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { toggle(false); launcher.focus(); } });
nudgeEl.querySelector('.sta-nudge__x').addEventListener('click', function (e) { e.stopPropagation(); hideNudge(); });
nudgeEl.addEventListener('click', function () { hideNudge(); toggle(true); });
log.addEventListener('click', onLogClick);
log.addEventListener('submit', function (e) {
if (e.target.classList.contains('sta-hand')) { e.preventDefault(); sendHandoff(e.target); }
});
}
function autosize() { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 120) + 'px'; }
function toggle(open) {
state.open = open;
panel.hidden = !open;
root.classList.toggle('is-open', open);
launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
if (open) {
hideNudge();
state.unread = 0; badge.hidden = true;
if (!state.history.length) welcome();
setTimeout(function () { input.focus(); scrollDown(); }, 30);
track('open', { template: CFG.template });
}
save();
}
function scrollDown() { log.scrollTop = log.scrollHeight; }
function push(msg) {
state.history.push(msg);
if (state.history.length > MAX_HISTORY) state.history = state.history.slice(-MAX_HISTORY);
render(msg);
save();
if (!state.open && msg.from === 'bot') { state.unread++; badge.textContent = String(state.unread); badge.hidden = false; }
}
function render(msg) {
var wrap = document.createElement('div');
wrap.className = 'sta-msg sta-msg--' + msg.from;
var html = '';
if (msg.text) html += '<div class="sta-bub">' + (msg.from === 'user' ? '<p>' + esc(msg.text) + '</p>' : md(msg.text)) + '</div>';
if (msg.cards && msg.cards.length) html += '<div class="sta-cards">' + msg.cards.map(cardHtml).join('') + '</div>';
if (msg.form === 'handoff') html += handoffHtml(msg.sent);
if (msg.chips && msg.chips.length) html += '<div class="sta-chips">' + msg.chips.map(function (c) { return '<button type="button" class="sta-chip" data-chip="' + esc(c) + '">' + esc(c) + '</button>'; }).join('') + '</div>';
if (msg.ai && !msg.rated) html += '<div class="sta-rate" data-rate-id="' + esc(msg.id) + '"><span>Helpful?</span><button type="button" data-rate="up" aria-label="Yes, helpful">&#128077;</button><button type="button" data-rate="down" aria-label="Not helpful">&#128078;</button></div>';
wrap.innerHTML = html;
wrap.dataset.id = msg.id || '';
log.appendChild(wrap);
scrollDown();
}
function cardHtml(h) {
var p = BY_HANDLE[h];
if (!p) return '';
var price = p.k === 'membership' ? 'from ' + money(p.p) + '/mo' : money(p.p);
var was = p.c && p.c > p.p ? '<s>' + money(p.c) + '</s>' : '';
var vault = (p.g || []).indexOf('members-vault') > -1;
var buy = (p.k === 'tool' && p.v && !vault)
? '<button type="button" class="sta-btn sta-btn--add" data-add="' + esc(p.v) + '" data-title="' + esc(p.t) + '">Add to cart</button>'
: '<a class="sta-btn sta-btn--add" href="' + esc(p.u) + '">' + (p.k === 'membership' ? 'Choose plan' : 'View') + '</a>';
return '<div class="sta-card">' +
(p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="64" height="64">' : '') +
'<div class="sta-card__b"><a class="sta-card__t" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
'<div class="sta-card__p"><b>' + price + '</b>' + was + '</div>' +
'<div class="sta-card__a"><a class="sta-btn" href="' + esc(p.u) + '">Details</a>' + buy + '</div></div></div>';
}
function handoffHtml(sent) {
if (sent) return '<div class="sta-sent">Message sent. We\'ll reply by email within 2 business days.</div>';
return '<form class="sta-hand" novalidate>' +
'<label>Name<input name="name" required maxlength="80" autocomplete="name" value="' + esc(CFG.firstName || '') + '"></label>' +
'<label>Email<input name="email" type="email" required maxlength="120" autocomplete="email"></label>' +
'<label>How can we help?<textarea name="body" rows="3" required maxlength="1500"></textarea></label>' +
'<div class="sta-hand__err" role="alert" hidden></div>' +
'<button type="submit" class="sta-btn sta-btn--add">Send to Steel Toe</button>' +
'<p class="sta-hand__note">We\'ll include this chat so you don\'t have to repeat yourself.</p></form>';
}
function bot(text, extra) {
var m = { from: 'bot', text: text, id: 'm' + Date.now() + Math.random().toString(36).slice(2, 6) };
if (extra) for (var k in extra) m[k] = extra[k];
push(m);
return m;
}
function typing(on) {
var t = log.querySelector('.sta-typing');
if (on && !t) {
t = document.createElement('div'); t.className = 'sta-msg sta-msg--bot sta-typing';
t.innerHTML = '<div class="sta-bub" aria-label="Assistant is typing"><i></i><i></i><i></i></div>';
log.appendChild(t); scrollDown();
} else if (!on && t) t.remove();
}
function botSoon(fn) { typing(true); setTimeout(function () { typing(false); fn(); }, 380 + Math.random() * 300); }
function welcome() {
var name = CFG.firstName ? ', ' + CFG.firstName : '';
if (CFG.memberTier) {
bot('Welcome back' + name + '! You\'re on the **' + CFG.memberTier + '** plan. Your tools are waiting in the [Members Vault](/collections/members-vault). What can I help with?',
{ chips: ['How do members download?', 'Find a tool for my trade', 'Cancel a membership', 'Talk to a person'] });
return;
}
var cur = CFG.currentProduct && BY_HANDLE[CFG.currentProduct];
var chips = ['Find a tool for my trade', 'Tell me about memberships', 'How do I get my files?', 'Refunds & guarantee', 'Talk to a person'];
if (cur) chips.unshift('Questions about this tool');
bot('Hey' + name + '! I\'m the Steel Toe assistant. I can help you find the right tool for your trade, explain memberships, or sort out downloads and orders. What do you need?', { chips: chips });
}
function restart() {
state.history = []; state.aiTurns = []; log.innerHTML = ''; save(); welcome(); input.focus();
}
function tradePicker() {
bot('What trade are you in?', { chips: TRADES.map(function (t) { return t.label; }).concat(['Something else']) });
}
function tradeRecs(trade) {
var tools = PRODUCTS.filter(function (p) { return p.k === 'tool' && (p.g || []).indexOf(trade.key) > -1; });
var bundle = tools.filter(function (p) { return (p.g || []).indexOf('bundle') > -1; })[0];
var singles = tools.filter(function (p) { return p !== bundle && !isAllTrades(p) && (p.g || []).indexOf('super-bundle') < 0; }).slice(0, 3);
var crew = PRODUCTS.filter(function (p) { return (p.g || []).indexOf(trade.key === 'electrical' || trade.key === 'roofing' ? 'tier-foreman' : 'tier-crew') > -1; })[0];
var cards = [];
if (bundle) cards.push(bundle.h);
singles.forEach(function (p) { cards.push(p.h); });
var txt = '**' + trade.label + '**: here\'s where most people start.';
if (bundle) txt += ' The **All-in-One Toolkit** has every ' + trade.label.toLowerCase() + ' tool for ' + money(bundle.p) + (bundle.c > bundle.p ? ' (' + money(bundle.c) + ' if bought separately)' : '') + '.';
if (crew) txt += ' Or get them all, plus updates, with a **' + ((crew.g || []).indexOf('tier-foreman') > -1 ? 'Foreman' : 'Crew') + ' membership** from ' + money(crew.p) + '/month.';
if (trade.key === 'general-contracting') { var big = BY_HANDLE['contractor-business-bundle-17-templates']; if (big) { cards.push(big.h); txt += ' Running bigger jobs? The **17-template Contractor Business Bundle** adds proposals, sub agreements, lien waivers and progress billing.'; } }
bot(txt, { cards: cards, chips: ['See all ' + trade.label + ' tools', 'Tell me about memberships', 'Something else'] });
}
function currentProductInfo() {
var p = BY_HANDLE[CFG.currentProduct];
if (!p) return tradePicker();
var tr = tradeOf(p);
var txt = '**' + p.t + '**' + (p.k === 'membership' ? '' : ' - ' + money(p.p)) + '\n\n' + p.d + '\n\nIt\'s an instant download that works in Excel and free Google Sheets, and it\'s print-ready.';
var chips = ['What formats are included?', 'Refunds & guarantee'];
if (tr) chips.unshift('Other ' + tr.label + ' tools');
bot(txt, { cards: [p.h], chips: chips });
}
function showMemberships() {
var m = PRODUCTS.filter(function (p) { return p.k === 'membership'; }).map(function (p) { return p.h; });
return m;
}
function handoff(prefill) {
bot(KB.filter(function (k) { return k.id === 'contact'; })[0].a, { form: 'handoff' });
if (prefill) setTimeout(function () {
var f = log.querySelector('.sta-msg:last-child .sta-hand textarea');
if (f && !f.value) f.value = prefill;
}, 10);
}
var CHIP_ACTIONS = {
'Find a tool for my trade': tradePicker,
'Something else': function () { bot('No problem. Tell me what you\'re trying to get done (for example "I need to stop underbidding jobs" or "I want customers to sign before I start") and I\'ll point you to the right tool. Or ask a person.', { chips: ['Talk to a person'] }); },
'Questions about this tool': currentProductInfo,
'Tell me about memberships': function () { answerKB('membership'); },
'Compare plans': function () { answerKB('membership'); },
'How do members download?': function () { answerKB('vault'); },
'Cancel a membership': function () { answerKB('cancel'); },
'How do I get my files?': function () { answerKB('delivery'); },
'What formats are included?': function () { answerKB('formats'); },
'Will it work on my phone?': function () { answerKB('phone'); },
'Refunds & guarantee': function () { answerKB('refund'); },
'Order help': function () { answerKB('order'); },
'Talk to a person': function () { handoff(); },
'Show toolkits': function () {
var b = PRODUCTS.filter(function (p) { return (p.g || []).indexOf('bundle') > -1; }).map(function (p) { return p.h; });
bot('Each All-in-One Toolkit has every tool for one trade, priced lower than buying them separately:', { cards: b, chips: ['Tell me about memberships'] });
},
'Show me the agreements': function () {
var a = PRODUCTS.filter(function (p) { return /agreement|waiver|change order/i.test(p.t); }).map(function (p) { return p.h; });
bot('Here are the agreements and forms that put the job in writing:', { cards: a.slice(0, 4) });
},
'Show business tools': function () {
var b = ['start-your-trade-business-kit', 'money-tools-pack', 'safety-program-pack', 'free-job-profit-calculator'].filter(function (h) { return BY_HANDLE[h]; });
bot('These work for every trade: [see all Business Tools](/collections/business-tools).', { cards: b, chips: ['Find a tool for my trade'] });
},
'Log in': function () { location.href = CFG.accountUrl || '/account'; },
'Open the Members Vault': function () { location.href = '/collections/members-vault'; }
};
function answerKB(id) {
var k = KB.filter(function (x) { return x.id === id; })[0];
if (!k) return;
var extra = { chips: k.chips || [] };
if (k.cards === 'memberships') extra.cards = showMemberships();
else if (Array.isArray(k.cards)) extra.cards = k.cards.filter(function (h) { return BY_HANDLE[h]; });
if (k.action === 'handoff') { handoff(); return; }
bot(k.a, extra);
}
function onChip(label) {
push({ from: 'user', text: label });
track('chip', { label: label });
var tr = TRADES.filter(function (t) { return t.label === label; })[0];
botSoon(function () {
if (tr) return tradeRecs(tr);
var m = label.match(/^(?:See all|Other) (.+?) tools$/);
if (m) {
var t2 = TRADES.filter(function (t) { return t.label === m[1]; })[0];
if (t2) { location.href = '/collections/' + t2.key; return; }
}
if (CHIP_ACTIONS[label]) return CHIP_ACTIONS[label]();
respond(label);
});
}
function submit() {
var q = input.value.trim();
if (!q) return;
if (q.length > 800) q = q.slice(0, 800);
input.value = ''; autosize();
push({ from: 'user', text: q });
track('message', { length: q.length });
respond(q);
}
function respond(q) {
var t = norm(q).trim();
var words = t.split(' ');
if (words.length <= 3 && GREETING_WORDS.some(function (g) { return t === g || t.indexOf(g + ' ') === 0; })) {
return botSoon(function () { bot('Hey! What can I help you with today?', { chips: ['Find a tool for my trade', 'Tell me about memberships', 'How do I get my files?'] }); });
}
if (words.length <= 5 && THANKS_WORDS.some(function (g) { return t.indexOf(g) > -1; })) {
return botSoon(function () { bot('Anytime. Anything else I can help with?', { chips: ['Find a tool for my trade', 'Talk to a person'] }); });
}
var kb = matchKB(q);
var trade = detectTrade(q);
var hits = searchProducts(q, trade, 3);
var strong = kb && (kb.score >= 2 || words.length <= 6);
if (CFG.endpoint && !(strong && kb.score >= 3) && !(trade && words.length <= 3)) {
return askAI(q, kb, hits);
}
botSoon(function () { localAnswer(q, kb, trade, hits, strong); });
}
function localAnswer(q, kb, trade, hits, strong) {
if (strong) {
var k = kb.k;
if (k.action === 'handoff') return handoff(q);
var extra = { chips: k.chips || [] };
if (k.cards === 'memberships') extra.cards = showMemberships();
else if (Array.isArray(k.cards)) extra.cards = k.cards.filter(function (h) { return BY_HANDLE[h]; });
else if (hits.length) extra.cards = hits.map(function (p) { return p.h; });
return bot(k.a, extra);
}
if (hits.length) {
return bot('These look like a match' + (trade ? ' for ' + trade.label.toLowerCase() : '') + ':', {
cards: hits.map(function (p) { return p.h; }), chips: trade ? ['See all ' + trade.label + ' tools', 'Talk to a person'] : ['Find a tool for my trade', 'Talk to a person'] });
}
if (trade) return tradeRecs(trade);
if (kb) return bot(kb.k.a, { chips: kb.k.chips || [], cards: Array.isArray(kb.k.cards) ? kb.k.cards.filter(function (h) { return BY_HANDLE[h]; }) : undefined });
bot('I\'m not sure about that one. I can help you find a tool, explain memberships, or answer questions about downloads and refunds. Or I can pass your question to a real person.', {
chips: ['Find a tool for my trade', 'Tell me about memberships', 'Talk to a person'] });
}
var busy = false;
function askAI(q, kb, hits) {
if (busy) return;
busy = true; sendBtn.disabled = true; typing(true);
state.aiTurns.push({ role: 'user', content: q });
var payload = {
messages: state.aiTurns.slice(-10),
context: {
page: location.pathname,
title: document.title.slice(0, 120),
product: CFG.currentProduct || null,
memberTier: CFG.memberTier || null,
loggedIn: !!CFG.loggedIn
},
catalog: PRODUCTS.map(function (p) {
return { handle: p.h, title: p.t, price: money(p.p), compareAt: p.c ? money(p.c) : null, kind: p.k, tags: (p.g || []).join(','), summary: p.d, url: p.u };
})
};
var ctrl = window.AbortController ? new AbortController() : null;
var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 25000);
fetch(CFG.endpoint.replace(/\/$/, '') + '/chat', {
method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined
}).then(function (r) {
if (!r.ok) throw new Error('status ' + r.status);
return r.json();
}).then(function (data) {
var reply = String(data.reply || '').trim();
if (!reply) throw new Error('empty');
state.aiTurns.push({ role: 'assistant', content: reply });
var cards = [];
reply = reply.replace(/\[\[product:([a-z0-9\-]+)\]\]/gi, function (m, h) { if (BY_HANDLE[h] && cards.indexOf(h) < 0) cards.push(h); return ''; }).replace(/\n{3,}/g, '\n\n').trim();
var wantsHuman = /\[\[handoff\]\]/i.test(reply);
reply = reply.replace(/\[\[handoff\]\]/gi, '').trim();
typing(false);
bot(reply, { cards: cards.slice(0, 4), ai: true, chips: wantsHuman ? [] : ['Talk to a person'] });
if (wantsHuman) handoff(q);
track('ai_reply', {});
}).catch(function () {
state.aiTurns.pop();
typing(false);
var words = norm(q).trim().split(' ');
localAnswer(q, kb, detectTrade(q), hits, kb && (kb.score >= 2 || words.length <= 6));
}).then(function () {
clearTimeout(timer); busy = false; sendBtn.disabled = false; save();
});
}
function onLogClick(e) {
var chip = e.target.closest('.sta-chip');
if (chip) { onChip(chip.getAttribute('data-chip')); return; }
var add = e.target.closest('[data-add]');
if (add) { addToCart(add); return; }
var rate = e.target.closest('[data-rate]');
if (rate) {
var box = rate.closest('.sta-rate');
var id = box.getAttribute('data-rate-id');
state.history.forEach(function (m) { if (m.id === id) m.rated = rate.getAttribute('data-rate'); });
box.innerHTML = '<span>Thanks for the feedback.</span>';
track('rating', { value: rate.getAttribute('data-rate') });
if (rate.getAttribute('data-rate') === 'down') {
bot('Sorry about that. Want me to pass your question to a real person?', { chips: ['Talk to a person'] });
}
save();
return;
}
}
function addToCart(btn) {
if (btn.disabled) return;
btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding...';
fetch('/cart/add.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-add')), quantity: 1 }] })
}).then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function () {
btn.textContent = 'Added';
track('add_to_cart', { variant: btn.getAttribute('data-add') });
try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e2) { /* ignore */ }
bot('Added **' + btn.getAttribute('data-title') + '** to your cart. [View cart](/cart) or [check out](/checkout) when you\'re ready.', { chips: ['Find a tool for my trade'] });
}).catch(function () {
btn.disabled = false; btn.textContent = label;
bot('That didn\'t go through. You can add it from the product page instead.', {});
});
}
function transcript() {
return state.history.slice(-20).map(function (m) {
return (m.from === 'user' ? 'Customer: ' : 'Assistant: ') + String(m.text || '').replace(/\s+/g, ' ').slice(0, 400);
}).join('\n');
}
function sendHandoff(f) {
var err = f.querySelector('.sta-hand__err');
var el = f.elements;
var name = el['name'].value.trim(), email = el['email'].value.trim(), body = el['body'].value.trim();
if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || !body) {
err.textContent = 'Please add your name, a valid email and your question.'; err.hidden = false; return;
}
var btn = f.querySelector('button[type=submit]');
btn.disabled = true; btn.textContent = 'Sending...';
var fd = new FormData();
fd.append('form_type', 'contact'); fd.append('utf8', '✓');
fd.append('contact[name]', name); fd.append('contact[email]', email);
fd.append('contact[body]', body + '\n\n--- Chat transcript ---\n' + transcript() + '\n\nPage: ' + location.href);
fd.append('contact[source]', 'Website assistant');
fetch('/contact#contact_form', { method: 'POST', body: fd, credentials: 'same-origin' }).then(function (r) {
var url = r.url || '';
if (!r.ok || /challenge/.test(url)) throw new Error('challenge');
return r.text().then(function (html) {
if (/contact_posted=true|form-status--success|Thanks for contacting/i.test(url + html)) return true;
if (/captcha|challenge/i.test(html)) throw new Error('challenge');
return true;
});
}).then(function () {
var msg = state.history.filter(function (m) { return m.form === 'handoff' && !m.sent; }).pop();
if (msg) msg.sent = true;
var wrap = f.closest('.sta-msg');
f.outerHTML = handoffHtml(true);
save();
track('handoff', {});
if (wrap) scrollDown();
}).catch(function () {
btn.disabled = false; btn.textContent = 'Send to Steel Toe';
var mail = 'mailto:' + EMAIL + '?subject=' + encodeURIComponent('Question from the website') + '&body=' + encodeURIComponent(body + '\n\n' + transcript());
err.innerHTML = 'We couldn\'t send that from here. <a href="' + esc(mail) + '">Email us instead</a> or use the <a href="/pages/contact">contact page</a>.';
err.hidden = false;
});
}
function showNudge(text) {
if (state.open || state.nudged) return;
state.nudged = true; save();
nudgeEl.querySelector('.sta-nudge__t').textContent = text;
nudgeEl.hidden = false;
track('nudge', { template: CFG.template });
}
function hideNudge() { if (nudgeEl) nudgeEl.hidden = true; }
function scheduleNudge() {
if (state.nudged || state.history.length) return;
var t = CFG.template;
var text = t === 'product' ? 'Questions about this tool? I can help in seconds.'
: t === 'collection' ? 'Not sure which tool you need? Tell me your trade.'
: t === 'cart' ? 'Questions before you check out? Ask me.' : null;
if (!text) return;
setTimeout(function () { showNudge(text); }, t === 'cart' ? 12000 : 25000);
}
function init() {
load();
build();
state.history.forEach(render);
if (state.open) toggle(true);
scheduleNudge();
window.SteelToeAssistant = { open: function () { toggle(true); }, close: function () { toggle(false); } };
document.addEventListener('click', function (e) {
var a = e.target.closest && e.target.closest('a[href="#ask-steel-toe"]');
if (a) { e.preventDefault(); toggle(true); }
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
